import logo from "assets/Whitespace_Logo_Colour.svg";
import { WhitespaceMenuWrapper } from "components/WhitespaceMenuWrapper/WhitespaceMenuWrapper";
import {
  Container, Row, Col, Image
} from "react-bootstrap";
import "./banner.scss";

const Banner = () => (
  <>
    <WhitespaceMenuWrapper />
    <section className="banner">
      <Container fluid>
        <Row>
          <Col xs={{ span: 12, order: 2 }} sm={{ span: 4, order: 1 }}>
            <h1 className="title">SSO Administration Portal</h1>
          </Col>
          <Col xs={{ span: 12, order: 1 }} sm={{ span: 4, order: 2 }}>
            <a href="https://whitespacews.com/" title="Whitespace Work Software" target="_blank" rel="noreferrer">
              <Image src={logo} alt="Whitespace Logo" height={52} />
            </a>
          </Col>
        </Row>
      </Container>
    </section>
  </>
);

export default Banner;
